import React, { useState } from "react";
import Select from "react-select";

const MultiSelectDropdown = ({ options, setData }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (e) => {
    const selectedValues = Array.isArray(e) ? e.map((x) => x.value) : [];
    setSelectedOptions(selectedValues);
    setData(selectedValues);
  };

  return (
    <div>
      <Select
        placeholder="Select Options"
        value={options.filter((obj) => selectedOptions.includes(obj.value))}
        options={options}
        onChange={handleChange}
        isMulti
        isClearable
        className="basic-multi-select"
        classNamePrefix="select"
      />
    </div>
  );
};

export default MultiSelectDropdown;
